import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

export const CrossBrandMenuItemDefaultBox = styled.div<{menuItemKey: string}>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.8rem 0;
    font-size: 1.4rem;
    line-height: 1;
    color: ${({theme, menuItemKey}) => menuItemKey === "sportCrossBrandMenuItem" ? theme.colors.sportBrandPrimary : ( menuItemKey === "pokerCrossBrandMenuItem" ? theme.colors.pokerBrandPrimary : theme.colors.text)};
    border: 2px solid ${({theme, menuItemKey}) => menuItemKey === "sportCrossBrandMenuItem" ? theme.colors.sportBrandPrimary : ( menuItemKey === "pokerCrossBrandMenuItem" ? theme.colors.pokerBrandPrimary : theme.colors.text)};;
    border-radius: 8px;
`;

export const CrossBrandMenuItemBox = styledByTheme(CrossBrandMenuItemDefaultBox)
    .apply();
